module.exports = __webpack_public_path__ + "static/media/a1d18e5b-d772-4dc4-b042-df83178f173a.d725531e.jpg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/chicago-council-headshots/dist/img/headshots/a1d18e5b-d772-4dc4-b042-df83178f173a.jpg
// module id = 839
// module chunks = 0